import { useQuery } from 'react-query';

import { DataRoomActivityLog, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomActivityLogQuery(
	guid: Guid | undefined,
	userGuid: Guid | null | undefined,
	name: string | null | undefined,
	page: number | null | undefined
) {
	const api = useApi();

	if (!page) {
		page = 1;
	}

	return useQuery(
		QueryKeys.DataRoom.ActivityLogs(guid, userGuid, name, page),
		() =>
			AxiosUtils.getResponseData<DataRoomActivityLog>(
				api.post(CerebroApiEndpoints.DataRooms.ActivityLogs(guid), {
					page: page,
					perPage: 10,
					name: name,
				})
			),
		{ enabled: guid !== undefined }
	);
}
